// Update-Hinweis: erscheint oben rechts, wenn eine neue App-Version deployt
// wurde (useVersionCheck). Calm-Sprache (design_language_calm_exploration):
// flache warme Fläche + Hairline + weicher Schatten, EINE Schrift (Hanken),
// Klartext sentence-case, freies dünnes Refresh-Icon (Strich 1.7, neutral),
// Ink-Button (Ton = T.text). KEIN Glow, KEIN pulsender roter Punkt, KEIN roter
// Strich — Rot gehört allein dem Marken-Punkt, hier kommt es nicht vor.

import { F } from '../styles/theme';
import { useTheme } from '../context/ThemeContext';
import { useT } from '../i18n/useT';
import { usePress } from './red/Press';

export default function UpdateBanner({ show, onReload }) {
  const { T } = useTheme();
  const { t } = useT();
  const { pressTransform, pressHandlers } = usePress();
  if (!show) return null;

  return (
    <>
      <style>{`
        @keyframes redUpdateIn {
          0%   { transform: translateY(-12px); opacity: 0; }
          100% { transform: translateY(0);     opacity: 1; }
        }
      `}</style>

      <div
        role="status"
        aria-live="polite"
        style={{
          width: 330,
          maxWidth: 'calc(100vw - 28px)',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 13,
          padding: '15px 16px',
          background: T.surface,
          border: `1px solid ${T.line || T.border}`,
          borderRadius: 16,
          boxShadow: T.cardShadow || (T.isDark
            ? '0 12px 34px rgba(0,0,0,0.34)'
            : '0 10px 30px rgba(60,48,28,0.12)'),
          animation: 'redUpdateIn 0.42s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        {/* Freies dünnes Refresh-Icon (Calm-Icon-Stil: Strich 1.7, runde Enden,
            neutral, KEINE Kachel, KEIN Akzent-Punkt). */}
        <span style={{ flexShrink: 0, marginTop: 1, color: T.sub, display: 'inline-flex' }}>
          <svg
            width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
          >
            <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            <path d="M3 21v-5h5" />
          </svg>
        </span>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontFamily: F.display || F.family, fontSize: 15.5, fontWeight: 600,
            color: T.text, letterSpacing: '-0.01em', lineHeight: 1.25,
          }}>
            {t('misc_update_title')}
          </div>
          <div style={{
            fontFamily: F.family, fontSize: 12.5, color: T.sub,
            lineHeight: 1.5, marginTop: 3,
          }}>
            {t('misc_update_body')}
          </div>

          {/* Ink-Button (Ton = T.text): im Hellen dunkel/cremefarben, im Dunklen
              hell/ink. KEIN Rot — Press-Squish wie app-weit (usePress). */}
          <button
            onClick={onReload}
            {...pressHandlers}
            style={{
              marginTop: 13,
              height: 38,
              padding: '0 16px',
              background: T.text,
              color: T.bg,
              border: 'none',
              borderRadius: 12,
              fontFamily: F.family,
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: '-0.01em',
              cursor: 'pointer',
              WebkitTapHighlightColor: 'transparent',
              transform: pressTransform,
              transition: 'transform 0.14s cubic-bezier(0.34, 1.5, 0.5, 1)',
            }}
          >
            {t('misc_update_reload')}
          </button>
        </div>
      </div>
    </>
  );
}
